import { IconEmail, Button } from '@sequencehq/core-components'

import { ProtectedButton } from 'lib/rbac'

type Props = {
  onClick?: () => void
  disabled?: boolean
  'data-testid': string
}

export const ButtonReviewAndSend = ({
  onClick,
  disabled,
  'data-testid': dataTestId
}: Props) => (
  <ProtectedButton permission="org.invoice:send">
    <Button
      variant="primary"
      onClick={onClick}
      disabled={disabled}
      leadingIcon={<IconEmail color="inherit" />}
      data-testid={dataTestId}
    >
      Review and send
    </Button>
  </ProtectedButton>
)
